import { createTypes } from "reduxsauce";

export default createTypes(
    `
    FETCH_CAR_LIST
    FETCH_CAR_LIST_SUCCESS
    FETCH_CAR_LIST_FAILURE

    FETCH_SIMILAR_CAR_LIST
    FETCH_SIMILAR_CAR_LIST_SUCCESS
    FETCH_SIMILAR_CAR_LIST_FAILURE

    UPDATE_SSR_STATUS
    RESET_CAR_LIST

    RELOAD_CAR_LIST

    FETCH_FAQ_DATA
    FETCH_FAQ_DATA_SUCCESS
    FETCH_FAQ_DATA_FAILURE

    CMS_CONFIG_INIT
    CMS_CONFIG_SUCCESS
    CMS_CONFIG_FAILURE

    FETCH_CAROUSEL_DATA
    FETCH_CAROUSEL_DATA_SUCCESS
    FETCH_CAROUSEL_DATA_FAILURE

    UPDATE_CLASSIFIED_HANDPICKED_BANNER_STATE

    FETCH_SEO_DATA
    FETCH_SEO_DATA_SUCCESS
    FETCH_SEO_DATA_FAILURE
`,
    {
        prefix: "carlisting/"
    }
);
